import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {ControlProps, ControlVariant} from './types';

export const Wrapper = styled.button<ControlProps>`
  margin-right: 6px;
  padding: 6px 4px 6px 10px;
  border-radius: 5px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  
  ${({variant, theme}) => {
    switch (variant) {
      case ControlVariant.Default: return css`
        background-color: ${transparentize(.9, theme.colors.white)};
      `;
      case ControlVariant.Accent: return css`
        background-color: ${theme.colors.primary};
      `;
    }
  }}
`;

export const Label = styled.span`
  line-height: 16px;
  font-size: 12px;
`;

export const Control = styled.div`
  padding: 0;
  display: grid;
  transform: scale(.4);
`;
